import React from 'react';
import CheckIcon from '@atlaskit/icon/glyph/check';
import CrossIcon from '@atlaskit/icon/glyph/cross';
/*
  These styles are taken fro the spinner style for button. There was not an
  easy way to share tehm between the two components.
*/
export var spinnerStyles = {
    display: 'flex',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
};
export var ActionIcon = function (_a) {
    var state = _a.state;
    switch (state) {
        case 'init':
        case 'loading':
            return null;
        case 'success':
            return (React.createElement("div", { "data-testId": "check-icon", style: spinnerStyles },
                React.createElement(CheckIcon, { size: "small", label: "check" })));
        case 'failure':
            return (React.createElement("div", { "data-testId": "cross-icon", style: spinnerStyles },
                React.createElement(CrossIcon, { size: "small", label: "check" })));
    }
};
//# sourceMappingURL=ActionIcon.js.map